import React from 'react';
import PropTypes from 'prop-types';
import {
  BRANDING_TYPE__ZEDOC,
  BRANDING_TYPE__ZESIGHT,
  BRANDING_TYPE__CLINICIAN,
} from '../../constants/branding';
import LogoZedoc from './LogoZedoc';
import LogoZeSight from './LogoZeSight';
import LogoClinician from './LogoClinician';
import LogoClinicianMini from './LogoClinicianMini';

const Logo = ({
  // eslint-disable-next-line react/prop-types
  className,
  branding,
  themeMode,
}) => {
  if (branding === BRANDING_TYPE__ZEDOC) {
    return <LogoZedoc className={className} themeMode={themeMode} />;
  }

  if (branding === BRANDING_TYPE__ZESIGHT) {
    return <LogoZeSight className={className} themeMode={themeMode} />;
  }

  if (branding === BRANDING_TYPE__CLINICIAN) {
    return <LogoClinician className={className} themeMode={themeMode} />;
  }

  return <LogoClinicianMini className={className} themeMode={themeMode} />;
};

Logo.propTypes = {
  branding: PropTypes.oneOf([BRANDING_TYPE__ZEDOC, BRANDING_TYPE__ZESIGHT]),
  themeMode: PropTypes.oneOf(['light', 'dark']),
};

Logo.defaultProps = {
  branding: null,
  themeMode: null,
};

export default Logo;
